// extracted by mini-css-extract-plugin
export default {"label":"FormDivider_label__VCk+e","container":"FormDivider_container__ziM9p","line":"FormDivider_line__cEcLq","spin":"FormDivider_spin__+N8vh"};